import React from "react";
import {
  LayoutGrid,
  CalendarRange,
  BookOpen,
  Boxes,
  Truck,
  Users,
  ClipboardList,
  Thermometer,
  BarChart3,
} from "lucide-react";

// The single, static place where feature names appear. No animation.
const FEATURES = [
  { icon: LayoutGrid, name: "Workflow", line: "What still needs to happen today." },
  { icon: CalendarRange, name: "Weekly Menu", line: "Plan the week, one service at a time." },
  { icon: BookOpen, name: "Recipes", line: "Every dish made the same way, every time." },
  { icon: Boxes, name: "Inventory", line: "Count once. Always know what you have." },
  { icon: Truck, name: "Deliveries", line: "Everything received, checked and recorded." },
  { icon: Users, name: "Suppliers", line: "Know where every product comes from." },
  { icon: ClipboardList, name: "Production", line: "See what was prepared, served and saved." },
  { icon: Thermometer, name: "Daily Checks", line: "Food safety, logged and easy to prove." },
  { icon: BarChart3, name: "Reports", line: "Clear numbers from your everyday work." },
];

export const FeaturesSection = () => (
  <section id="features" className="relative px-6 pt-14 pb-10 md:px-12 md:pt-24 md:pb-14 lg:px-24">
    <div className="mx-auto w-full max-w-[1500px]">
      <div className="max-w-3xl">
        <span className="font-body text-[11px] uppercase tracking-[0.32em] text-[#EA6A43]">
          The whole kitchen
        </span>
        <h2 className="mt-6 font-display text-6xl font-black leading-[0.92] tracking-tighter text-[#1b1a18] sm:text-7xl">
          Everything your kitchen needs.
          <br />
          One connected system.
        </h2>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-x-16 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map((f) => (
          <div key={f.name} className="border-t border-[var(--mo-line)] py-8">
            <f.icon size={18} className="text-[#EA6A43]/80" strokeWidth={1.4} />
            <div className="mt-5 font-display text-2xl font-bold tracking-tight text-[#1b1a18]">
              {f.name}
            </div>
            <div className="mt-2 font-body text-[15px] leading-relaxed text-[#6b665e]">
              {f.line}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
